<template>
  <v-dialog max-width="550" v-model="dialog.shows.showSetting">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="sendForm">
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col class="mb-0 py-0" cols="6" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['transfer'])"
                  :error-messages="
                    !_.isEmpty(errorsTransferMinAmount)
                      ? errorsTransferMinAmount
                      : apiFormErrors['transfer']
                  "
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.users.cols.setting.transfer.amount_min.title'
                    )
                  "
                  @blur="$v.form.transfer.amount_min.$touch()"
                  @input="$v.form.transfer.amount_min.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-transfer"
                  v-model="form.transfer.amount_min"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="6" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['transfer'])"
                  :error-messages="
                    !_.isEmpty(errorsTransferMaxAmount)
                      ? errorsTransferMaxAmount
                      : apiFormErrors['transfer']
                  "
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.users.cols.setting.transfer.amount_max.title'
                    )
                  "
                  @blur="$v.form.transfer.amount_max.$touch()"
                  @input="$v.form.transfer.amount_max.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-transfer"
                  v-model="form.transfer.amount_max"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="6" sm="6">
                <v-switch
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.users.cols.setting.transfer.active.title'
                    )
                  "
                  v-model="form.transfer.active"
                ></v-switch>
              </v-col>
              <v-col class="mb-0 py-0" cols="6" sm="6">
                <v-text-field
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.users.cols.setting.transfer.daily_withdrawal_limit.title'
                    )
                  "
                  autocomplete="off"
                  prepend-icon="mdi-shield-off-outline"
                  v-model="form.transfer.daily_withdrawal_limit"
                ></v-text-field>
              </v-col>

              <v-col class="mb-0 py-0" cols="6" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['payment'])"
                  :error-messages="
                    !_.isEmpty(errorsPaymentMinAmount)
                      ? errorsPaymentMinAmount
                      : apiFormErrors['payment']
                  "
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.users.cols.setting.payment.amount_min.title'
                    )
                  "
                  @blur="$v.form.payment.amount_min.$touch()"
                  @input="$v.form.payment.amount_min.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-transfer"
                  v-model="form.payment.amount_min"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="6" sm="6">
                <v-text-field
                  :error="!_.isNull(apiFormErrors['payment'])"
                  :error-messages="
                    !_.isEmpty(errorsPaymentMaxAmount)
                      ? errorsPaymentMaxAmount
                      : apiFormErrors['payment']
                  "
                  :label="
                    $vuetify.lang.t(
                      '$vuetify.users.cols.setting.payment.amount_max.title'
                    )
                  "
                  @blur="$v.form.payment.amount_max.$touch()"
                  @input="$v.form.payment.amount_max.$touch()"
                  autocomplete="off"
                  prepend-icon="mdi-transfer"
                  v-model="form.payment.amount_max"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.shows.showSetting = false" text
            >{{ $vuetify.lang.t("$vuetify.btn.close") }}
          </v-btn>
          <v-btn :loading="loadingBtn" color="secondary" text type="submit"
            >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import FormMixin from "../../mixins/Common/Forms";
import CONSTANTS from "../../helpers/Constants";
import { required, integer } from "vuelidate/lib/validators";
import URLPath from "../../helpers/URL";

export default {
  name: "Settings",
  mixins: [FormMixin],
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.users.setting.title",
          shows: {
            showSetting: false
          },
          saveBtnTitle: "$vuetify.btn.save",
          action: "edit"
        };
      }
    },
    form: {
      type: Object,
      default: function() {
        return CONSTANTS.defaultUserSetting();
      }
    }
  },
  validations() {
    let validators = {
      form: {
        transfer: {
          amount_min: {
            required,
            integer,
            minValue: val => {
              return (
                CONSTANTS.defaultTransferSetting().amount_min <= Number(val)
              );
            }
          },
          amount_max: {
            integer,
            max: val => {
              if (val) return Number(val) && Number(val) >= this.form.transfer.amount_min;
              return true;
            }
          }
        },
        payment: {
          amount_min: {
            required,
            integer,
            minValue: val => {
              return (
                CONSTANTS.defaultPaymentSetting().amount_min <= Number(val)
              );
            }
          },
          amount_max: {
            integer,
            max: val => {
              if (val) return Number(val) && Number(val) >= this.form.payment.amount_min;
              return true;
            }
          }
        }
      }
    };
    return validators;
  },
  data: () => ({
    loadingBtn: false
  }),
  methods: {
    sendForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let self = this;
        this.loadingBtn = true;
        this.save(this.getFormParam())
          .then(() => {
            this.$emit("getItems");
            self.$store.dispatch("setNotification", {
              status: true,
              message: self.$vuetify.lang.t("$vuetify.success_form")
            });
          })
          .catch(() => {})
          .finally(() => {
            self.loadingBtn = false;
            self.dialog.shows.showSetting = false;
          });
      }
    },
    setForm(item) {
      this.form["id"] = item.id;
      const settings = item.settings;
      if (this._.isEmpty(settings)) {
        this.form.transfer.amount_min = null;
        this.form.transfer.amount_max = null;
        this.form.payment.amount_min = null;
        this.form.payment.amount_max = null;
      } else {
        this.form.transfer.amount_min = !this._.isEmpty(settings.transfer)
          ? settings.transfer.amount_min
          : null;
        this.form.transfer.amount_max = !this._.isEmpty(settings.transfer)
          ? settings.transfer.amount_max
          : null;
        this.form.transfer.daily_withdrawal_limit = !this._.isEmpty(
          settings.transfer
        )
          ? settings.transfer.daily_withdrawal_limit
          : null;
        this.form.transfer.active = !this._.isEmpty(settings.transfer)
          ? settings.transfer.active
          : false;
        this.form.payment.amount_min = !this._.isEmpty(settings.payment)
          ? settings.payment.amount_min
          : null;
        this.form.payment.amount_max = !this._.isEmpty(settings.payment)
          ? settings.payment.amount_max
          : null;
      }
    },
    getFormParam() {
      let params = {};
      params["url"] = URLPath.USER.SETTINGS.URI.replace(
        "{USER_ID}",
        this.form["id"]
      );
      let data = this._.omit(this.form, ["id"]);
      data["transfer"]["daily_withdrawal_limit"] = data["transfer"][
        "daily_withdrawal_limit"
      ]
        ? data["transfer"]["daily_withdrawal_limit"]
        : 0;
      params["data"] = data;

      params["method"] = URLPath.USER.SETTINGS.METHOD;
      return params;
    },
    getTransferSetting() {
      return CONSTANTS.defaultTransferSetting();
    }
  },
  computed: {
    errorsTransferMinAmount() {
      let errors = [];
      if (!this.$v.form.transfer.amount_min.$dirty) return errors;

      !this.$v.form.transfer.amount_min.required &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.transfer.amount_min.required"
          )
        );

      !this.$v.form.transfer.amount_min.integer &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.transfer.amount_min.integer"
          )
        );

      !this.$v.form.transfer.amount_min.minValue &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.transfer.amount_min.min",
            [CONSTANTS.defaultTransferSetting().amount_min]
          )
        );

      return errors;
    },
    errorsTransferMaxAmount() {
      let errors = [];
      if (!this.$v.form.transfer.amount_max.$dirty) return errors;

      !this.$v.form.transfer.amount_max.integer &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.transfer.amount_max.integer"
          )
        );

      !this.$v.form.transfer.amount_max.max &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.transfer.amount_max.max",
            [this.form.transfer.amount_max]
          )
        );

      return errors;
    },
    errorsPaymentMinAmount() {
      let errors = [];
      if (!this.$v.form.payment.amount_min.$dirty) return errors;

      !this.$v.form.payment.amount_min.required &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.payment.amount_min.required"
          )
        );

      !this.$v.form.payment.amount_min.integer &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.payment.amount_min.integer"
          )
        );

      return errors;
    },
    errorsPaymentMaxAmount() {
      let errors = [];
      if (!this.$v.form.payment.amount_max.$dirty) return errors;

      !this.$v.form.payment.amount_max.integer &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.payment.amount_max.integer"
          )
        );

      !this.$v.form.payment.amount_max.max &&
        errors.push(
          this.$vuetify.lang.t(
            "$vuetify.users.cols.setting.payment.amount_max.max",
            [this.form.payment.amount_max]
          )
        );

      return errors;
    }
  }
};
</script>

<style scoped></style>
